import { Plus } from "lucide-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "../../../components";
import FormHeader from "../../../components/form/FormHeader";
import { useGetAlertTypeOptions } from "../../common/public-options";
import { useCreateNotification } from "../hooks/useCreateNotification";
import { NotificationForm } from "../components/form";
import type { CreateNotificationFormValues } from "../components/form";
import { goBackOrGoHome } from "../../../utils/navigation";

function CreateNotificationPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { loading, error, success, createNotification } = useCreateNotification();
  const formId = "notification-create-form";
  const {
    alertTypes,
    loading: alertTypesLoading,
    error: alertTypesError,
    refetch: refetchAlertTypes,
  } = useGetAlertTypeOptions();

  useEffect(() => {
    if (!success) {
      return;
    }

    navigate("/notification");
  }, [navigate, success]);

  const handleSubmit = async (values: CreateNotificationFormValues) => {
    await createNotification(values);
  };

  return (
    <div className="bg-white dark:bg-gray-900">
      <FormHeader
        onBack={() => goBackOrGoHome(navigate)}
        title={t("notification.create_new_notification")}
        subtitle=""
        backLabel={t("common.back")}
        actions={
          <Button
            type="submit"
            form={formId}
            disabled={loading}
            className="flex items-center gap-2 bg-emerald-500 text-white"
          >
            <Plus className="h-4 w-4" />
            {loading ? t("notification.creating") : t("notification.create_notification")}
          </Button>
        }
      />

      <NotificationForm
        formId={formId}
        loading={loading}
        error={error}
        alertTypes={alertTypes}
        alertTypesLoading={alertTypesLoading}
        alertTypesError={alertTypesError}
        onRetryAlertTypes={refetchAlertTypes}
        onSubmit={handleSubmit}
      />
    </div>
  );
}

export default CreateNotificationPage;
